// Import React and Component
import React, { Component } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import { Offline, Detector } from 'react-detect-offline'
import Login from './views/Login/container'
import Home from './views/Home/container'
import RegisterCozy from './views/RegisterCozy/container'
import SetTemperatureSchedule from './views/SetTemperatureSchedule/container'
import EditTemperatureSettings from './views/EditTemperatureSettings/container'
import AccountInformation from './views/AccountInformation/container'
import EditRoom from './views/EditRoom/container'
import CopySelectedSchedule from './views/CopySelectedSchedule/container'
import EditSchedule from './views/EditSchedule/container'
import ForgotPassword from './views/ForgotPassword/container'
import ResetPassword from './views/ResetPassword/container'
import SignUp from './views/SignUp/container'
import NotFound from './views/NotFound/container'
import history from './views/history'

// Private routes can't be accessed without authentication
const PrivateRoute = ({ component, ...rest }) => {
  // Validate is user is logged in
  const isAuthed = localStorage.getItem('Authorization')
  return (
    <Route
      {...rest}
      exact
      render={props =>
        isAuthed ? (
          <div>
            <Detector
              render={({ online }) => (
                <div className={online ? '' : 'internet-offline'}>
                  <Offline>You are offline at the moment!</Offline>
                </div>
              )}
            />
            {React.createElement(component, props)}
          </div>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
}

class App extends Component {
  componentWillMount() {
    // If authorized then send user to Home page
    if (localStorage.getItem('Authorization') && history.location.pathname === '/login') {
      history.push('/home')
    }
  }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/login" />} />
          <Route path="/signup" component={SignUp} />
          <Route path="/login" component={Login} />
          <PrivateRoute path="/home" component={Home} />
          <PrivateRoute path="/register-cozy" component={RegisterCozy} />
          <PrivateRoute path="/temperature-schedule" component={SetTemperatureSchedule} />
          <PrivateRoute path="/edit-temp" component={EditTemperatureSettings} />
          <PrivateRoute path="/account-info" component={AccountInformation} />
          <PrivateRoute path="/edit-room" component={EditRoom} />
          <PrivateRoute path="/copy-schedule" component={CopySelectedSchedule} />
          <PrivateRoute path="/edit-schedule" component={EditSchedule} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/reset-password/:token" component={ResetPassword} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js